export default "__VITE_ASSET__a0204c1e__"